import { render, staticRenderFns } from "./growingTrends.vue?vue&type=template&id=f1fb08ba&scoped=true"
import script from "./growingTrends.vue?vue&type=script&lang=js"
export * from "./growingTrends.vue?vue&type=script&lang=js"
import style0 from "./growingTrends.vue?vue&type=style&index=0&id=f1fb08ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb08ba",
  null
  
)

export default component.exports